import { useEffect, useCallback } from 'react';
import { useRoutes, Outlet } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import {
  useLazyGetNotificationCenterPermissionsQuery,
  useLazyGetNotificationCenterWhitelabelQuery,
} from './store/dictionaries/services';
import { setActivePermissions } from './store/dictionaries/slices';
import Notifications from './hoc/notifications/notifications';
import NotificationCenter from './hoc/center/notification-center';

import ROUTES from './routes';

export const routes = {
  path: ROUTES.NOTIFICATIONS,
  element: <Notifications />,
  children: [
    {
      path: ROUTES.NOTIFICATIONS_CENTER,
      element: <NotificationCenter />,
    },
    {
      path: ROUTES.NOTIFICATIONS_SETTINGS,
      element: <div />,
    },
  ],
};

const NotificationCenterRoutes = () => {
  const elements = useRoutes([
    {
      path: '/',
      element: (
        <Outlet
          context={{
            connectionStatus: null,
            sendMessage: null,
          }}
        />
      ),
      children: [{ ...routes }],
    },
  ]);

  const dispatch = useAppDispatch();

  const { activePermissions, whitelabel } = useAppSelector(
    (state) => state.notificaticationCenterDictionaries,
  );

  const [getNotificationCenterPermissions] =
    useLazyGetNotificationCenterPermissionsQuery();
  const [getNotificationCenterWhitelabel] =
    useLazyGetNotificationCenterWhitelabelQuery();

  const getNotificationCenterPermissionsAction = useCallback(() => {
    getNotificationCenterPermissions();
  }, []);

  const permissions = JSON.parse(
    localStorage.getItem('activePermissions') as string,
  );

  useEffect(() => {
    const companyName = localStorage.getItem('companyName');

    if (!companyName) {
      getNotificationCenterWhitelabel();
    }
  }, []);

  useEffect(() => {
    if (whitelabel) {
      localStorage.setItem('companyName', whitelabel?.data?.value?.companyName);
    }
  }, [whitelabel]);

  useEffect(() => {
    if (permissions && !activePermissions) {
      dispatch(setActivePermissions(permissions));
    } else if (!permissions && !activePermissions) {
      getNotificationCenterPermissionsAction();
    }
  }, [
    permissions,
    getNotificationCenterPermissionsAction,
    dispatch,
    activePermissions,
  ]);

  return elements;
};

export default NotificationCenterRoutes;
